import type { MemberType } from '@/components/People/PeopleFilterSelector';
import type { JoinKind } from '@/stores/useJoinIntentStore';

type JoinPathname = '/organization/join' | '/team/join';

type JoinKindConfiguration = {
  defaultMemberType: MemberType;
  joinPathname: JoinPathname;
};

const joinKindConfiguration = {
  organization: {
    defaultMemberType: 'non_participant',
    joinPathname: '/organization/join',
  },
  team: {
    defaultMemberType: 'participant',
    joinPathname: '/team/join',
  },
} satisfies Record<JoinKind, JoinKindConfiguration>;

export function getJoinKindConfiguration(kind: JoinKind) {
  return joinKindConfiguration[kind];
}

export function resolveJoinMemberType(
  kind: JoinKind,
  memberType: string | undefined,
): MemberType {
  if (memberType === 'participant' || memberType === 'non_participant') {
    return memberType;
  }

  return getJoinKindConfiguration(kind).defaultMemberType;
}
